/* ══════════════════════════════════════════════════════════════════════════
 * THE PASSWORD CHECKLIST — one for every screen that sets a password
 *
 * Al-Noor, 10 Oct 2026, after testers in Calgary could not join: "why are
 * you just saying, putting those letters in there? Why don't you say at least
 * eight characters with whatever it is? … see what the best practice is."
 *
 * Every requirement stays on screen under the box and is ticked as it is met
 * (Mailchimp's sign-up; web.dev and uxcel's sign-up guidance). A tick AND the
 * words change, never colour alone; the list is announced as it changes.
 * Join, Forgot password and Settings all draw this one, so they cannot say
 * three different things.
 * ══════════════════════════════════════════════════════════════════════════ */
import React from 'react';
import { CHECKS } from './password.js';

export function PwChecklist({ pw, id }) {
  const v = String(pw || '');
  return (
    <ul className="pwcheck" id={id} aria-live="polite">
      {CHECKS.map((c) => {
        const met = c.ok(v);
        return (
          <li key={c.label} className={met ? 'met' : ''}>
            <span className="pwtick" aria-hidden="true">{met ? '✓' : ''}</span>
            <span>{c.label}</span>
          </li>
        );
      })}
    </ul>
  );
}
